"use client";

type Location = {
  id: string;
  name: string;
  address?: string | null;
  phone?: string | null;
};

type LocationSelectorProps = {
  locations: Location[];
  value?: string;
  onChange: (locationId: string) => void;
  required?: boolean;
  error?: string;
};

export function LocationSelector({
  locations,
  value,
  onChange,
  required,
  error,
}: LocationSelectorProps) {
  if (locations.length === 0) return null;

  return (
    <div>
      <label className="block text-sm font-medium mb-2">
        Select Location {required && <span className="text-destructive">*</span>}
      </label>

      <div className="grid gap-2">
        {locations.map((loc) => (
          <button
            key={loc.id}
            type="button"
            onClick={() => onChange(loc.id)}
            className={`flex items-center gap-3 rounded-lg border p-3 text-left transition-all ${
              value === loc.id
                ? "border-primary bg-primary/5 ring-2 ring-primary/20"
                : "border-input bg-background hover:bg-muted/50"
            }`}
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-foreground">{loc.name}</p>
              {loc.address && (
                <p className="text-xs text-muted-foreground">{loc.address}</p>
              )}
            </div>
            {value === loc.id && (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-primary shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
          </button>
        ))}
      </div>

      {error && <p className="mt-1 text-sm text-destructive">{error}</p>}
    </div>
  );
}
